export { default } from './EmbeddedNonBrandedHeader';
export type { Props as EmbeddedNonBrandedHeaderProps } from './EmbeddedNonBrandedHeader';
